import React, { Component } from "react";
import "./LandingHeader.scss";
import logo from "../../assets/logo.png";
import { Link } from "react-router-dom";
import { FaUserPlus, FaPhoneAlt, FaUser } from "react-icons/fa";
import { FiLogIn } from "react-icons/fi";
import { setCurrentLang, setCurrentUser } from "../../redux/user/user.action";
import { Menu, Dropdown, Button } from "antd";
import Avatar from "antd/lib/avatar/avatar";
import { userLogout } from "../../network/auth.network";
import MenuItem from "antd/lib/menu/MenuItem";

class LandingHeader extends Component {
  state = {
    noBg: false,
  };

  componentDidMount() {
    //const { location } = this.props;
    //     if(location.pathname.includes('/finance')){
    //         this.setState({noBg : true})
    // }
  }

  changeLang = (lang) => {
    // document.getElementsByTagName("html")[0].setAttribute("lang", lang);
    localStorage.setItem("lang", lang);
    this.props.dispatch(setCurrentLang(lang));
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  handelMenuSelect = (val) => {
    if (val.key === "3") {
      userLogout(
        (res) => {
          localStorage.removeItem("tokenCi");
          localStorage.setItem("isAuthenticatedCi", false);
          localStorage.setItem("role", null);
          this.props.dispatch(setCurrentUser(null));
          this.props.history.push("/");
        },
        (error) => {}
      );
    }
  };

  render() {
    //const { currentLang, currentUser, location } = this.props;
    const { noBg } = this.state;

    return (
      <div className={`header-wrapper ${noBg && "no-bg"} `}>
        <div className="container">
          <div className="header-content">
            <div className="logo-holder">
              <img src={logo} alt="logo" />
            </div>
            <div className="menu-list-wrapper">
              <ul>
                <li>
                  <a href="https://osoolard.com/" activeClassName="active">
                    الرئيسية
                  </a>
                </li>
                <li>
                  <a
                    href="https://osoolard.com/%d8%ae%d8%af%d9%85%d8%a7%d8%aa%d9%86%d8%a7/"
                    activeClassName="active"
                  >
                    خدماتنا
                  </a>
                </li>
                <li>
                  <a
                    href="https://osoolard.com/%d9%86%d8%a8%d8%b0%d8%a9-%d8%b9%d9%86%d8%a7/"
                    activeClassName="active"
                  >
                    نبذة عنا
                  </a>
                </li>
                <li>
                  <a
                    href="https://osoolard.com/%d8%a7%d9%84%d9%85%d8%af%d9%88%d9%86%d8%a9/"
                    activeClassName="active"
                  >
                    المدونة
                  </a>
                </li>
                <li>
                  <a
                    href="https://osoolard.com/%d9%85%d8%b9%d8%b1%d8%b6-%d8%a7%d9%84%d8%b5%d9%88%d8%b1/"
                    activeClassName="active"
                  >
                    معرض الصور
                  </a>
                </li>
                <li>
                  <a
                    href="https://osoolard.com/%d8%aa%d9%88%d8%a7%d8%b5%d9%84-%d9%85%d8%b9%d9%86%d8%a7/"
                    activeClassName="active"
                  >
                    تواصل معنا
                  </a>
                </li>
              </ul>
            </div>

            <div className="header-action-holder">
              <a href="tel:+920020310" className="tel-holder">
                <FaPhoneAlt />
                920020310
              </a>
              <Dropdown
                overlayClassName="page-landing-user-dropdown"
                overlay={
                  <Menu>
                    <Menu.Item icon={<FiLogIn />}>
                      <Link to="/signin-account">تسجيل الدخول</Link>
                    </Menu.Item>
                    <MenuItem icon={<FaUserPlus />}>
                      <Link to="/signup">حساب جديد</Link>
                    </MenuItem>
                  </Menu>
                }
                trigger={["click"]}
              >
                <Button
                  type="primary"
                  size="large"
                  className=""
                  icon={<FaUser />}
                >
                  حسابي
                </Button>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LandingHeader;
